import React, { useState, useEffect, useContext } from 'react';
import { connect } from "react-redux";
import moment from "moment"
import _ from "lodash"
import { dateTimeFormat } from "../../utils"

import { PageContainer, Xpagination, Xtable } from '../../component/Xcomponent';
import { convertTZ, dateFormat } from "../../utils"

import { SearchOutlined, StarOutlined, StarFilled } from '@ant-design/icons'
import { Col, Form, Row, Space } from 'antd';
import { InputBox, XButton } from './TestimonialStyle';
import { getTestimonial, getTestimonialReset } from './../../action/getTestimonialAction';
import HeaderContext from '../../context/HeaderContext';

const Testimonial = (props) => {

    const {
        getTestimonial, getTestimonialState, getTestimonialReset, getDoctorDetailState,
    } = props
    const initialSearchData = {
        search: "",
    }

    const [tableData, setTableData] = useState([])
    const [refresh, setRefresh] = useState(0)
    const [searchData, setSearchData] = useState(initialSearchData)
    const page = new URLSearchParams().get("page")
    console.log(page)

    const [pagination, setPagination] = useState({
        page: page ? page : 1,
        records: 10,
    })

    const [form] = Form.useForm()

    const {setTitle} = useContext(HeaderContext);
    setTitle("Reviews");

    //columns
    const columns = [
        {
            title: "Date",
            dataIndex: "date",
            key: "date",
            render: (data) => (
                <span style={{ fontWeight: 600 }}>{data}</span>
            )
        },
        {
            title: "Patient Name",
            dataIndex: "pname",
            key: "pname",
            render: (data) => (
                <span style={{ fontWeight: 600 }}>{data}</span>
            )
        },
        {
            title: "Comment",
            dataIndex: "comment",
            key: "comment",
            render: (data) => (
                <span style={{ fontWeight: 600 }}>{data}</span>
            )
        },
        {
            title: "Rating",
            dataIndex: "rating",
            key: "rating",
            render: (rating) => (
                [0,1,2,3,4].map((data, index) => {
                    if (rating > index) {
                        return <StarFilled style={{ color: '#fadb14' }}/>
                    }else {
                        return <StarOutlined style={{ color: '#fadb14' }}/>
                    }               
                })
                )
        },
        
    ]

    useEffect (() => {
        if (getTestimonialState.apiState === "sucess") {
            let tableData = []
            
            getTestimonialState.list.result.map((data) => {
                // let date =  moment(data.to_date).utc().unix()
                // let current_date = convertTZ(
                //     moment().format('YYYY-MM-DD HH:mm:ss') + " +0000",
                //     "Asia/Kolkata"
                // );
                // current_date = moment(current_date).utc().unix()
                // let show = false
                // if (date <= current_date) {
                //     show = true
                // }
                // console.log(data)
                tableData.push({
                    date: dateTimeFormat(data.createdAt),
                    pname: `${data.patient_id.name?.firstName} ${data.patient_id.name?.lastName}`,
                    rating: data.rating,
                    comment: data.comment,
                })
            })
            tableData = _.orderBy(tableData).reverse()
            
            setTableData(tableData)
            // console.log(tableData)
        } else if (getTestimonialState.apiState === " error"){  
        }
    }, [getTestimonialState])

    useEffect(() => {
        getTestimonial({
            search: searchData.search,
            page: pagination.page,
            records: pagination.records,
        })
    }, [pagination, refresh])


    const handleOnChange = (e) => {
        setSearchData({ ...searchData, [e.target.name]: e.target.value })
    }

    const handleReset = () => {
        form.resetFields()
        setSearchData(initialSearchData)
        setPagination({ ...pagination, ['page']: 1 })
    }

    //search 
    const searchTestimonial = () => {
        setPagination({ ...pagination, ['page']: 1 })
    }

  return (
    <>
        {
            getDoctorDetailState.apiState==="success" && getDoctorDetailState.data.is_dcp_activated=="Yes" ? 
            <PageContainer>
                <Form
                    form={form}
                    onFinish={searchTestimonial}
                    layout="vertical"
                >
                    <Row gutter={24}>
                        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                            <Form.Item name="search">
                                <InputBox type="text" name="search" onChange={handleOnChange} size="large" placeholder="Search Testimonial" prefix={<SearchOutlined style={{ color: "#7e7b7b9c" }} />} >
                                </InputBox>
                            </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={6} xl={4}>
                                <Space>
                                    <Form.Item name="search_btn">
                                        <XButton
                                            className="search_btn"
                                            size="large"
                                            type="primary"
                                            htmlType="submit"
                                        >
                                            Search
                                        </XButton>
                                    </Form.Item>
                                    <Form.Item name="reset_btn">
                                        <XButton
                                            type="primary"
                                            ghost
                                            onClick={() => handleReset()}
                                            size="large"
                                            style={{ width: 100 }}
                                        >
                                            Reset
                                        </XButton>
                                    </Form.Item>
                                </Space>
                            </Col>
                    </Row>
                </Form>
                <div className = "Testimonial list">
                    <Xtable
                    size="middle"
                    columns={columns}
                    dataSource={tableData}
                    pagination={false}
                    scroll={{ x: 768 }}
                    />
                    <Xpagination
                    style={{gap:"5px",flexWrap:"wrap"}}
                    pageSizeOptions={["10", "25", "50", "100", "500"]}
                    showSizeChanger
                    total={getTestimonialState.pagination?.total_records}
                    onChange={(page, pageSize) => setPagination({ page: page, records: pageSize })}
                    current={pagination.page}
                    defaultPageSize={pagination.records}
                    defaultCurrent={1}
                    />
                </div>
            </PageContainer>
            :
            <PageContainer>
                <h6>Access Not Authorized</h6>
            </PageContainer>
        }
    </>
  )
}

const mapStateToProps =(state) => ({
    getTestimonialState: state.getTestimonial,
    getDoctorDetailState: state.getDoctorDetail,
})

const mapDispatchToProps =(dispatch) => ({
    getTestimonial: (params) => dispatch(getTestimonial(params)),
    getTestimonialReset: () => dispatch(getTestimonialReset()), 
})

export default connect (mapStateToProps, mapDispatchToProps)(Testimonial)